import * as React from "react";
const SvgFiRrPicnic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-picnic_svg__a)">
      <path
        fill="#062147"
        d="M23.283 9.034A3 3 0 0 0 20.93 8C19.5-2.6 4.492-2.59 3.07 8a3.018 3.018 0 0 0-3.024 3.425l1.06 7.424A6.024 6.024 0 0 0 7.036 24h9.957a6.025 6.025 0 0 0 5.932-5.15l1.06-7.425a3 3 0 0 0-.703-2.39M12 2a7 7 0 0 1 6.911 6H5.09A7 7 0 0 1 12 2m6.2 8-3.85 3.857a.5.5 0 0 1-.706 0L9.792 10zm2.746 8.565A4.02 4.02 0 0 1 16.994 22H7.037a4.02 4.02 0 0 1-3.955-3.435l-1.059-7.423A1 1 0 0 1 3.013 10h3.954l5.265 5.271a2.49 2.49 0 0 0 3.531 0l5.263-5.27a1 1 0 0 1 .982 1.14z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-picnic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPicnic;
